import React, {Component} from 'react';
import Main from '../Main';

class MeManager extends Component{
    render(){
        return(
            <div>
                <Main/>
                <p>Me manager</p>
            </div>
        )
    }
}

export default MeManager;
